<it-card teaser="true" shadow="true">
  <div *ngIf="loading">
    <it-progress-bar indeterminate="true" [value]="0" color="primary"></it-progress-bar>
  </div>

  <div *ngIf="!loading">
    <dl class="row">
      <ng-container *ngIf="dischargeInfo">
        <dt class="col-sm-6">Data di dimissione prevista:</dt>
        <dd class="col-sm-6">
          {{ getDateFromType('DDP')?.date ? (getDateFromType('DDP')?.date | date: 'dd/MM/yyyy') : '(-)' }}
        </dd>
        <dt class="col-sm-6">Data e ora di dimissione effettiva:</dt>
        <dd class="col-sm-6">
          {{ getDateFromType('DDE')?.date ? (getDateFromType('DDE')?.date | date: 'dd/MM/yyyy HH:mm') : '(-)' }}
        </dd>
      </ng-container>
      <ng-container>
        <dt class="col-sm-6">Data invio richiesta:</dt>
        <dd class="col-sm-6">
          {{ enrollementData?.sendDate ? (enrollementData?.sendDate | date: 'dd/MM/yyyy HH:mm') : (enrollementData?.insertDate ? (enrollementData?.insertDate | date: 'dd/MM/yyyy HH:mm') : '(-)') }}
        </dd>
      </ng-container>
      <ng-container *ngIf="enrollementData?.cancellationDate">
        <dt class="col-sm-6">Invio cancellato:</dt>
        <dd class="col-sm-6">
          {{ enrollementData?.cancellationDate ? 'Sì'  : 'No' }}
        </dd>
      </ng-container>
      <ng-container>
        <dt class="col-sm-6">Esito invio:</dt>
        <dd class="col-sm-6">
          {{ enrollementData?.result}}
        </dd>
      </ng-container>
      <ng-container *ngIf="enrollementData?.note">
        <dt class="col-sm-6">Note:</dt>
        <dd class="col-sm-6">
          {{ enrollementData?.note}}
      </dd>
      </ng-container>
      <ng-container>
        <dt class="col-sm-6">Data di arruolamento:</dt>
        <dd class="col-sm-6">
          {{ enrollementData?.enrollmentDate ? (enrollementData?.enrollmentDate | date: 'dd/MM/yyyy') : '(-)' }}
        </dd>
      </ng-container>
      <ng-container>
        <dt class="col-sm-6">Numero protocollo ADI:</dt>
        <dd class="col-sm-6">
          {{ enrollementData?.externalIdentifier ? enrollementData?.externalIdentifier  : '(-)' }}
        </dd>
      </ng-container>
      <ng-container *ngIf="enrollementData?.reopeningNote">
        <dt class="col-sm-6">Note di riapertura:</dt>
        <dd class="col-sm-6">
          {{ enrollementData?.reopeningNote ? enrollementData?.reopeningNote  : '(-)' }}
        </dd>
      </ng-container>
    </dl>
  </div>
</it-card>